import EbisAlert from './EbisAlert';

export default EbisAlert;
